import {
	NavigateBefore as NavigateBeforeIcon,
	NavigateNext as NavigateNextIcon,
} from '@mui/icons-material';
import { IconButton, Stack, TextField, Typography } from '@mui/material';
import {
	DatePicker as MuiDatePicker,
	DatePickerProps as MuiDatePickerProps,
} from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import { PeriodicityEnum } from '~enums';
import { longMonthAndYearFormatter } from '~utils/dateUtils';

interface DatePickerProps extends MuiDatePickerProps<Dayjs> {
	periodicity?: PeriodicityEnum;
	disableNavigateButtons?: boolean;
}

const DatePicker = ({
	periodicity = PeriodicityEnum.Month,
	disableNavigateButtons = false,
	value,
	disableOpenPicker = true,
	maxDate = dayjs(),
	readOnly = true,
	...muiDatePickerProps
}: DatePickerProps) => {
	const { t } = useTranslation();

	const getFormat = (periodicity: PeriodicityEnum | 'daily') => {
		switch (periodicity) {
			case PeriodicityEnum.Year:
				return 'YYYY';
			case PeriodicityEnum.Month:
				return 'MMMM YYYY';
			default:
				return 'DD MMMM YYYY';
		}
	};

	const mapPeriodicity = (periodicity: PeriodicityEnum | 'daily'): dayjs.ManipulateType => {
		switch (periodicity) {
			case PeriodicityEnum.Year:
				return 'year';
			case PeriodicityEnum.Month:
				return 'month';
			default:
				return 'day';
		}
	};

	if (value == null) {
		return 'unknown';
	}

	return (
		<Stack direction='row' spacing={0.5} sx={{ alignItems: 'center' }}>
			{!disableNavigateButtons && (
				<IconButton
					onClick={() =>
						muiDatePickerProps.onChange?.(value?.subtract(1, mapPeriodicity(periodicity)))
					}
					sx={{ height: 'fit-content' }}
				>
					<NavigateBeforeIcon />
				</IconButton>
			)}
			<Typography variant='body1' sx={{ minWidth: 120, textAlign: 'center' }}>
				{periodicity === PeriodicityEnum.Month ?
					longMonthAndYearFormatter.format(value.toDate())
				:	value.get('year')}
			</Typography>
			{/* <MuiDatePicker
				{...muiDatePickerProps}
				value={value}
				format={getFormat(periodicity)}
				readOnly={readOnly}
				maxDate={maxDate}
				disableOpenPicker={disableOpenPicker}
				slotProps={{
					textField: {
						sx: {
							border: 'none',
							'input': {
								textAlign: 'center',
							}
						},
						variant: 'standard',
					},
				}}
			/> */}
			{!disableNavigateButtons && (
				<IconButton
					disabled={value != null && value?.add(1, mapPeriodicity(periodicity)) > maxDate}
					onClick={() => muiDatePickerProps.onChange?.(value?.add(1, mapPeriodicity(periodicity)))}
					sx={{ height: 'fit-content' }}
				>
					<NavigateNextIcon />
				</IconButton>
			)}
		</Stack>
	);
};

export default DatePicker;
